import React from 'react'

import { cn } from '@/shared/lib/utils'

export function ListGroup({
	className,
	...props
}: {
	className?: string
} & React.HTMLAttributes<HTMLUListElement>) {
	return <ul className={cn('list-group', className)} {...props} />
}
export default ListGroup
